import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { ReactComponent as PurchasesIconSVG } from 'assets/img/menu_purchases.svg';

export const StyledPurchasesPage = styled.div`
  width: ${scaleSize(1500)}px;
  height: ${scaleSize(1080)}px;
  margin: ${scaleSize(100)}px 0 0 ${scaleSize(220)}px;
  position: relative;
`;

export const PurchasesIcon = styled(PurchasesIconSVG)`
  width: ${scaleSize(192)}px;
  height: ${scaleSize(192)}px;
`;
